import { render, staticRenderFns } from "./create-new-models.html?vue&type=template&id=289bd8c4&scoped=true&external"
import script from "./create-new-models.js?vue&type=script&lang=js&external"
export * from "./create-new-models.js?vue&type=script&lang=js&external"
import style0 from "./create-new-models.scss?vue&type=style&index=0&id=289bd8c4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bd8c4",
  null
  
)

export default component.exports